"use client";
import React, { useState, useEffect, useRef } from "react";
import Image from "next/image";
import styles from "./HomePage.module.css";
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const FadeInSection = dynamic(() => import('@/Component/Hooks/FadeInSection'), { ssr: false });

import arrowImg from "@/assets/Icon/Down_Icon.png";
import { homepageData } from "@/Component/accordion";
import { useRouter } from 'next/navigation'; 
import enterImg from "@/assets/Icon/Enter.png";
import scroll_icon from "@/assets/Icon/Scroll_Icon.png";
import { OnOpenUrl } from "@/Component/accordion"
import appleIcon from "@/assets/Icon/appleicon.png";
import googleIcon from "@/assets/Icon/googleicon.png";
import { useTranslation } from "react-i18next";


const HomePage = () => {
  const router  = useRouter();

  const videoRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [index, setIndex] = useState(0);
  const {t} = useTranslation();
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateProgress = () => {
      const current = video.currentTime;
      const duration = video.duration || 1;
      setProgress(current / duration);
    };

    video.addEventListener("timeupdate", updateProgress);

    return () => {
      video.removeEventListener("timeupdate", updateProgress);
    };
  }, []);

  const updateVideo = (index) => {
    const targetIndex = index % homepageData.Media.length;
    const video = videoRef.current;
    setIndex(targetIndex);
    if (video) {
      video.load(); // 소스 재로드
      video.play().catch((e) => {
        console.warn("재생 실패:", e);
      });
    }
  }
  return (
    <>
      <Header></Header>

      <div className={styles.home__container}>

        <div className={styles.swiper__container}>
          <video autoPlay playsInline muted className={styles.video} onEnded={() => {
            updateVideo(Math.abs(1 - index))
          }} ref={videoRef}>
            <source src={homepageData.Media[index].video_url} type="video/mp4" />
          </video>
          <div className={styles.swiper__content}>
            <div className={styles.pointer__event}>
              <nav className={styles.move__to} onClick={() => { OnOpenUrl({ content: homepageData.Media[index], navigate : router }) }}>
                <span className={styles.move__to__title}>{t(homepageData.Media[index].titleKey)}</span>
                <Image src={enterImg} className={styles.move__to__img} alt="move icon">
                </Image>
              </nav>
              <span  className={styles.move__to__description}>{t(homepageData.Media[index].descriptionKey)}</span>
            </div>
            <div className={styles.page__direction}>
              <div className={styles.page__num}>
                <span>
                  {(index + 1).toString().padStart(2, "0")}
                </span>
                <div className={styles.page__line}>
                  <div className={`${styles.page__line} ${styles.actvie}`} style={{ width: `${progress * 100}%` }}>

                  </div>
                </div>

                <span>
                  {Math.abs((index) - homepageData.Media.length).toString().padStart(2, "0")}
                </span>
              </div>
              <div className={styles.btn}>
                <div className={styles.btn__content} onClick={() => {
                  updateVideo(Math.abs(1 - index))
                }}>
                  <Image src={arrowImg} className={`${styles.btn__img} ${styles.left}`} alt="left arrow icon" priority={true}> 
                  </Image>
                </div>

                <div className={styles.btn__content} onClick={() => {
                  updateVideo(Math.abs(1 - index))
                }}>
                  <Image src={arrowImg} className={`${styles.btn__img} ${styles.right}`} alt="right arrow icon" priority={true}>
                  </Image>
                </div>
              </div>

            </div>
            <div className={styles.scroll__btn}>
              <Image src={scroll_icon} className={styles.scroll__btn__image} alt="scroll icon" priority={true} />
            </div>
          </div>
        </div>
        <div className={styles.home__content}>
          <FadeInSection className={styles.our__games__container}>
            <span className={styles.our__games__title}>{t("Home.Project.Title")}</span>

            <div className={styles.games__wrapper}>
              {homepageData.OurProject.map((data, index) => (

                <div className={styles.games__grid} key={index} >
                  <Image className={styles.games__grid__img} src={data.img_url} alt="game image" width={300} height={300}>
                  </Image>
                  <div className={styles.games__grid__right}>
                      <div className={styles.games__text__content}>
                        <div className={styles.games__game__name} onClick={() => { OnOpenUrl({ content: data ,navigate : router }) }}> 
                         <span  className={styles.games__game__name__text}>{t(data.nameKey)}</span>
                          <Image className={styles.games__game__arrow__img} src={scroll_icon} alt="scroll icon">
                          </Image>
                        </div>
                        <span className={styles.games__text__content__description}>{t(data.nameKey)}</span>
                      </div>

                      <div className={styles.games__store}>
                        <Image className={styles.games__store__img}src={googleIcon} alt="google play icon"
                        onClick={() => { OnOpenUrl({ content: {open_url:data.google_store_url},navigate : router }) }}
                        >
                        </Image>
                        <Image className={styles.games__store__apple__img} src={appleIcon} alt="apple store icon"
                        onClick={() => { OnOpenUrl({ content: {open_url : data.apple_store_url} ,navigate : router }) }}
                        >
                        </Image>
                       </div> 
                   </div> 
                </div>
              ))}
            </div>
          </FadeInSection>
          <FadeInSection className={styles.join__container}>
            <span  className={styles.our__games__title}>{t("Home.Contact.Title")}</span>
            <div className={styles.join__wrapper}>
              {homepageData.Join.map((data, index) => (

                <div className={styles.join__card} key={index} onClick={() => {
                  OnOpenUrl({content : data,navigate : router } )
                }}>
                  <div className={styles.join__card__outline}>
                  </div>
                  <Image className={styles.join__card__img} src={data.img_url} alt="card icon">
                  </Image>
                  <div className={styles.join__card__title}>
                    <span className={styles.join__card__title__text}>{t(data.titleKey)}</span>
                    <span className={styles.join__card__description__text}>{t(data.descriptionKey)}</span>
                  </div>
                    <span className={styles.join__card__btn}>{t(data.btn_textKey)}</span>
                </div>
              ))}
            </div>
          </FadeInSection>
        </div>
      </div>
      <Footer>

      </Footer>
    </>
  )
}

export default HomePage;